<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      temporary
      app
    >
    <v-list>
      <v-list-tile
        v-for="link in links"
        :key="link.title"
        :to="link.link"
      >
        <v-list-tile-content>
          <v-list-tile-title>{{ link.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    </v-navigation-drawer>
      <v-toolbar class="white" app>
        <v-toolbar-side-icon class="hidden-md-and-up" @click="drawer = !drawer"></v-toolbar-side-icon>
        <v-toolbar-title style="font-family:'Pacifico', cursive; overflow:visible;">Cakes by Karen Richardson</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down">
          <v-btn v-for="link in links" flat :to="link.link" :key="link.title" exact router>{{link.title}}</v-btn>
        </v-toolbar-items>
      </v-toolbar>
    <v-content app>
      <router-view/>
    </v-content>
    <v-speed-dial
            v-model="fab"
            bottom
            right
            fixed
          >
            <v-btn
              slot="activator"
              v-model="fab"
              color="primary"
              dark
              fab
            >
              <v-icon>more_horiz</v-icon>
              <v-icon>close</v-icon>
            </v-btn>
            <v-btn
              fab
              dark
              small
              color="blue darken-4"
              href="https://facebook.com/cakesbykarenrichardsonuk"
            >
              <v-icon>fab fa-facebook-f</v-icon>
            </v-btn>
            <v-btn
              fab
              dark
              small
              color="red"
              href="https://www.instagram.com/cakesbykarenrichardson/"
            >
              <v-icon>fab fa-instagram</v-icon>
            </v-btn>
            <v-btn
              fab
              dark
              small
              color="indigo"
              href="mailto:karen@cakesbykarenrichardson.co.uk"
            >
              <v-icon>email</v-icon>
            </v-btn>
            <v-btn
              fab
              dark
              small
              color="green"
              href="tel:07985790947"
            >
              <v-icon>phone</v-icon>
            </v-btn>
          </v-speed-dial>
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      fab: false,
      drawer: false,
      links: [
        {link: '/', title: 'Home'},
        {link: 'wedding', title: 'Wedding'},
        {link: 'birthday', title: 'Birthday'},
        {link: 'cupcakes', title: 'Cupcakes'},
        {link: 'other', title: 'Other Occasions'},
        {link: 'contact', title: 'Contact'}
      ]
    }
  },
  name: 'App'
}
</script>

<style>
  h1, h5 {
    font-weight: normal;
    font-family: 'Pacifico', cursive;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue